export function PostCarData(type, userData) {


    let BaseURL = `http://35.154.224.75:1338/car/`;
    //let BaseURL = 'http://35.154.224.75:1337/user/login/';
    
    //console.log("JSON FORMAT CARDATA+++++++++++++++",JSON.stringify(userData))
    return new Promise((resolve, reject) =>{
          fetch(BaseURL+type, {
               method: 'POST',
               body: JSON.stringify(userData)
               })
               .then((response) => response.json())
               .then((res) => {
                console.log("SSSSSSSSSSSSSSS",res);
                resolve(res);
               })
               .catch((error) => {
                reject(error);
                });
         });
}


   


// WEBPACK FOOTER //
// ./Service/PostCarData.js